import type { FC } from 'react'
import React, { useContext } from 'react'
import styled from 'styled-components'

import SmallPill from '@/components/SmallPill'
import ctx from '@/context/AppContext'
import { useDeleteDocumentMutation } from '@/lib/apollo'

interface Props {
  customerId: string
  subjectId: string
  documentId: string
  onCancel: () => void
}

const Container = styled.div`
  display: grid;
  justify-content: center;
  text-align: center;
  color: black;
  background: white;
  padding: 15px;
`

const ButtonsContainer = styled.div`
  display: grid;
  grid-template-columns: min-content min-content;
  justify-content: center;
  gap: 10px;
`

const DeleteDocument: FC<Props> = ({ customerId, subjectId, documentId, onCancel }) => {
  const [performDeleteDocument, { loading, error }] = useDeleteDocumentMutation()
  const { personId } = useContext(ctx)

  return (
    <Container>
      <p>Are you sure you wish to delete this document?</p>
      {error && <p>An unexpected error occurred. {error?.message}</p>}
      <ButtonsContainer>
        <SmallPill type="button" onClick={onCancel}>
          Cancel
        </SmallPill>
        <SmallPill
          type="button"
          disabled={loading}
          styleType="danger"
          onClick={() =>
            performDeleteDocument({
              variables: {
                customerId,
                subjectId,
                userId: personId ?? '',
                documentId,
              },
            })
          }
        >
          Delete
        </SmallPill>
      </ButtonsContainer>
    </Container>
  )
}

export default DeleteDocument
